import { render, staticRenderFns } from "./emettitori.vue?vue&type=template&id=bfb10aac"
import script from "./emettitori.vue?vue&type=script&lang=js"
export * from "./emettitori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports